module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12 row-rm-padding"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title pull-right"
  }, [_c('button', {
    staticClass: "btn primary-btn-my clear-new-modal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addPopUp = true
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.addPopUp
    },
    on: {
      "update:mdActive": function($event) {
        _vm.addPopUp = $event
      },
      "update:md-active": function($event) {
        _vm.addPopUp = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Add New Document\n      "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addPopUp = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n        ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from-padding modal-width-100"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClass('name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "100",
      "id": "name",
      "name": "name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), (!_vm.$v.form.name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.name.required && this.newFormBackendValidation.name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('description')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Description")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "500",
      "id": "description",
      "name": "description"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), (!_vm.$v.form.description.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The description is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.description.required && this.newFormBackendValidation.description.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.description.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    staticClass: "category_id",
    class: _vm.getValidationClass('category_id')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Category")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "category_id",
      "id": "category_id"
    },
    model: {
      value: (_vm.form.category_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_id", $$v)
      },
      expression: "form.category_id"
    }
  }, _vm._l((_vm.categoriesSelection), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 1), _vm._v(" "), (!_vm.$v.form.category_id.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The category is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.category_id.required && this.newFormBackendValidation.category_id.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.category_id.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    staticClass: "products",
    class: _vm.getValidationClass('products')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Products")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "products",
      "id": "products",
      "multiple": ""
    },
    model: {
      value: (_vm.form.products),
      callback: function($$v) {
        _vm.$set(_vm.form, "products", $$v)
      },
      expression: "form.products"
    }
  }, _vm._l((_vm.productsSelection), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 1), _vm._v(" "), (!_vm.$v.form.products.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The product is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.products.required && this.newFormBackendValidation.products.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.products.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('industries')
  }, [(_vm.IndustrySelected.length != 0) ? _c('label', {
    staticClass: "multiLable"
  }, [_vm._v("Industries")]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "Add industries as new tag",
      "placeholder": "Search or add an industries",
      "label": "name",
      "track-by": "id",
      "options": _vm.IndustriesList,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: (_vm.IndustrySelected),
      callback: function($$v) {
        _vm.IndustrySelected = $$v
      },
      expression: "IndustrySelected"
    }
  }), _vm._v(" "), (!_vm.$v.form.industries.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Industries is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.industries.required && this.editFormBackendValidation.industries.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.industries.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    staticClass: "device_type",
    class: _vm.getValidationClass('device_type')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Allowed Device Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "device_type",
      "id": "device_type",
      "md-dense": ""
    },
    model: {
      value: (_vm.form.device_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "device_type", $$v)
      },
      expression: "form.device_type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "b"
    }
  }, [_vm._v("Mobile and Web")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("Only Mobile")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "w"
    }
  }, [_vm._v("Only Web")])], 1), _vm._v(" "), (!_vm.$v.form.device_type.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Allowed Device Type is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.device_type.required && this.newFormBackendValidation.device_type.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.device_type.errorMsg))]) : _vm._e()], 1), _vm._v(" "), (_vm.isUploadImage) ? _c('div', {
    staticClass: "box-upload",
    class: _vm.getValidationClass('n_fileNewFrm')
  }, [_c('div', {
    staticClass: "box-upload-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    ref: "myFiles",
    staticClass: "box-upload-file",
    attrs: {
      "id": "n_fileNewFrm",
      "name": "n_fileNewFrm",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.previewFiles($event.target.files, true)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Upload PDF")])])]) : _vm._e(), _vm._v(" "), (_vm.isUploadingImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('sync-loader', {
    attrs: {
      "loading": _vm.isUploadingImage,
      "color": _vm.editModalColor,
      "size": _vm.editModalSize,
      "width": _vm.editModalWidth,
      "margin": _vm.editModalMargin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUploadedImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('div', {
    staticClass: "box-upload-icon"
  }, [_c('i', {
    staticClass: "fa fa-check-square",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    ref: "myFiles",
    staticClass: "box-upload-file",
    attrs: {
      "id": "fileNewFrm",
      "name": "fileNewFrm",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.previewFiles($event.target.files, true)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "border-bottom": "10px"
    }
  }, [_vm._v("Completed")])])]) : _vm._e(), _vm._v(" "), (_vm.isUploadErrorImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('div', {
    staticClass: "box-upload-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    ref: "myFiles",
    staticClass: "box-upload-file",
    attrs: {
      "id": "fileNewFrm",
      "name": "fileNewFrm",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.previewFiles($event.target.files, true)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("PDF upload failed. Please retry.")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateNewDocumentSubmission
    }
  }, [_vm._v("Add Document")]), _vm._v("\n             \n          "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.newModalLoading,
      "color": _vm.newModalColor,
      "size": _vm.newModalSize,
      "width": _vm.newModalWidth,
      "margin": _vm.newModalMargin
    }
  })], 1)])], 1), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.editModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.editModal = $event
      },
      "update:md-active": function($event) {
        _vm.editModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Edit Document\n      "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n        ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from-padding modal-width-100"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClass('name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "100",
      "id": "name",
      "name": "name"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  }), _vm._v(" "), (!_vm.$v.editForm.name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.name.required && this.editFormBackendValidation.name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('description')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Description")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "500",
      "id": "description",
      "name": "description"
    },
    model: {
      value: (_vm.editForm.description),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "description", $$v)
      },
      expression: "editForm.description"
    }
  }), _vm._v(" "), (!_vm.$v.editForm.description.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The description is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.description.required && this.editFormBackendValidation.description.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.description.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    staticClass: "category_id",
    class: _vm.getValidationClass('category_id')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Category")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "category",
      "id": "category"
    },
    model: {
      value: (_vm.editForm.category_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "category_id", $$v)
      },
      expression: "editForm.category_id"
    }
  }, _vm._l((_vm.categoriesSelection), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 1), _vm._v(" "), (!_vm.$v.editForm.category_id.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The category is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.category_id.required && this.editFormBackendValidation.category_id.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.category_id.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    staticClass: "products",
    class: _vm.getValidationClass('products')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Products")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "products",
      "id": "products",
      "multiple": ""
    },
    model: {
      value: (_vm.editForm.products),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "products", $$v)
      },
      expression: "editForm.products"
    }
  }, _vm._l((_vm.productsSelection), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 1), _vm._v(" "), (!_vm.$v.editForm.products.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The product is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.products.required && this.editFormBackendValidation.products.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.products.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('industries')
  }, [(_vm.IndustrySelected.length != 0) ? _c('label', {
    staticClass: "multiLable"
  }, [_vm._v("Industries")]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "Add industries as new tag",
      "placeholder": "Search or add an industries",
      "label": "name",
      "track-by": "id",
      "options": _vm.IndustriesList,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: (_vm.IndustrySelected),
      callback: function($$v) {
        _vm.IndustrySelected = $$v
      },
      expression: "IndustrySelected"
    }
  }), _vm._v(" "), (!_vm.$v.editForm.industries.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Industries is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.industries.required && this.editFormBackendValidation.industries.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.industries.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    staticClass: "device_type",
    class: _vm.getValidationClass('device_type')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Allowed Device Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "device_type",
      "id": "device_type",
      "md-dense": ""
    },
    model: {
      value: (_vm.editForm.device_type),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "device_type", $$v)
      },
      expression: "editForm.device_type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "b"
    }
  }, [_vm._v("Mobile and Web")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("Only Mobile")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "w"
    }
  }, [_vm._v("Only Web")])], 1), _vm._v(" "), (!_vm.$v.editForm.device_type.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Allowed Device Type is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.device_type.required && this.editFormBackendValidation.device_type.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.device_type.errorMsg))]) : _vm._e()], 1), _vm._v(" "), (_vm.isUploadImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('div', {
    staticClass: "box-upload-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    ref: "myFiles",
    staticClass: "box-upload-file",
    attrs: {
      "id": "file",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.previewFiles($event.target.files, false)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Upload PDF")])])]) : _vm._e(), _vm._v(" "), (_vm.isUploadingImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('sync-loader', {
    attrs: {
      "loading": _vm.isUploadingImage,
      "color": _vm.editModalColor,
      "size": _vm.editModalSize,
      "width": _vm.editModalWidth,
      "margin": _vm.editModalMargin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUploadedImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('div', {
    staticClass: "box-upload-icon"
  }, [_c('i', {
    staticClass: "fa fa-check-square",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    ref: "myFiles",
    staticClass: "box-upload-file",
    attrs: {
      "id": "file",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.previewFiles($event.target.files, false)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Completed")]), _vm._v(" "), (_vm.isUploadedImage) ? _c('img', {
    staticClass: "img-thumbnail",
    attrs: {
      "src": _vm.awsImageFixedUrl + _vm.editForm.thumbnail,
      "alt": "icon"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isUploadErrorImage) ? _c('div', {
    staticClass: "box-upload"
  }, [_c('div', {
    staticClass: "box-upload-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    ref: "myFiles",
    staticClass: "box-upload-file",
    attrs: {
      "id": "file",
      "name": "fileNewFrm",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.previewFiles($event.target.files, false)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("PDF upload failed. Please retry.")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateEditDocumentSubmission
    }
  }, [_vm._v("\n            Update\n          ")]), _vm._v("\n             \n          "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.editModalLoading,
      "color": _vm.editModalColor,
      "size": _vm.editModalSize,
      "width": _vm.editModalWidth,
      "margin": _vm.editModalMargin
    }
  })], 1)])], 1), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.notifiModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.notifiModal = $event
      },
      "update:md-active": function($event) {
        _vm.notifiModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Notification Control\n      "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.notifiModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n        ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from-padding modal-width-100"
  }, [_c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Select Filter Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "product",
      "id": "product"
    },
    on: {
      "md-selected": function($event) {
        return _vm.loadFilterData(_vm.filter.filter_type)
      }
    },
    model: {
      value: (_vm.filter.filter_type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "filter_type", $$v)
      },
      expression: "filter.filter_type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "industry"
    }
  }, [_vm._v("Industries")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "organization"
    }
  }, [_vm._v("Organizations")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "state"
    }
  }, [_vm._v("States")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "user"
    }
  }, [_vm._v("Users")])], 1)], 1), _vm._v(" "), _c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Select options")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "product",
      "id": "product",
      "multiple": "",
      "disabled": _vm.isDisabledOption
    },
    on: {
      "md-selected": function($event) {
        return _vm.GetUserCount(_vm.selectFilter_value)
      }
    },
    model: {
      value: (_vm.selectFilter_value),
      callback: function($$v) {
        _vm.selectFilter_value = $$v
      },
      expression: "selectFilter_value"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.filterType), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  })], 2)], 1), _vm._v(" "), _c('span', [_vm._v("Users Count : " + _vm._s(_vm.filterUserCount))]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.triggerNotification
    }
  }, [_vm._v("\n            Trigger Notification\n          ")]), _vm._v("\n             \n          "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.editModalLoading,
      "color": _vm.editModalColor,
      "size": _vm.editModalSize,
      "width": _vm.editModalWidth,
      "margin": _vm.editModalMargin
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "tableData"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Date\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Name\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "aria-label": "Platform(s): activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Category\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "32%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Description\n\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("RCP Products\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "5%"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("State\n                    ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c22b9752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/DocumentsView.vue
// module id = 2117
// module chunks = 1